import React from 'react'
import PropTypes from 'prop-types'

function ReturnButton({ buttonClassName }) {
  return (
    <a
      href="/events"
      className={`btn btn-dark btn-outline-default btn-white ${buttonClassName}`}
    >
      Back to events
    </a>
  )
}

ReturnButton.propTypes = {
  buttonClassName: PropTypes.string.isRequired,
}

export default ReturnButton
